import { render, staticRenderFns } from "./comentariosView.vue?vue&type=template&id=3707c45a&"
import script from "./comentariosView.vue?vue&type=script&lang=js&"
export * from "./comentariosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports